{
  "slug": "how-can-i-find-out-my-iq",
  "title": "मैं अपना IQ कैसे पता कर सकता हूँ?",
  "description": "निरीक्षण योग्य पेशेवर मूल्यांकन के साथ ऑनलाइन आईक्यू-शैली के परीक्षणों की तुलना करें और एक विश्वसनीय संज्ञानात्मक स्कोर प्राप्त करने और व्याख्या करने के तरीके को सीखें।",
  "summary": "अपने IQ को जानने का सही तरीका उद्देश्य पर निर्भर करता है। एक सावधानीपूर्वक ऑनलाइन परीक्षण एक संकेतात्मक अनुमान प्रदान कर सकता है, जबकि नैदानिक, शैक्षिक, या योग्यता संबंधी निर्णयों के लिए उपयुक्त निगरानी वाले मूल्यांकन की आवश्यकता होती है।",
  "category": "आईक्यू आवश्यक",
  "sections": [
    {
      "heading": "आपका अंक प्राप्त करने के कारण के साथ प्रारंभ करें",
      "paragraphs": [
        "जिज्ञासा, अभ्यास, शैक्षिक योजना, नैदानिक मूल्यांकन और सदस्यता योग्यता अलग-अलग लक्ष्य हैं। एक अनौपचारिक ऑनलाइन अनुमान जिज्ञासा के प्रश्न का जवाब दे सकता है लेकिन एक संरक्षित पेशेवर उपकरण की जगह नहीं ले सकता है।",
        "यदि परिणाम उपचार, आवास, शिक्षा, रोजगार या औपचारिक आवेदन को प्रभावित कर सकता है, तो एक योग्य मनोवैज्ञानिक या संबंधित संगठन से पूछें कि कौन सा परीक्षण और दस्तावेज वह स्वीकार करता है।"
      ]
    },
    {
      "heading": "ऑनलाइन परीक्षा में क्या देखना है",
      "paragraphs": [
        "एक जिम्मेदार ऑनलाइन परीक्षण यह स्पष्ट करता है कि यह क्या नमूना लेता है, इसमें कितना समय लगता है, तुलनात्मक स्कोर कैसे बनाए जाते हैं, और यह क्या स्थापित नहीं कर सकता है।",
        "आराम से समय निकालकर मूल्यांकन करें, शांत वातावरण का प्रयोग करें, समय के नियमों का पालन करें और बाहरी मदद से बचें. एक ही वस्तुओं को दोहराने से अभ्यास प्रभाव उत्पन्न हो सकते हैं, इसलिए बाद में प्राप्त परिणाम स्वचालित रूप से बेहतर अनुमान नहीं है."
      ]
    },
    {
      "heading": "क्या पेशेवर परीक्षण जोड़ता है",
      "paragraphs": [
        "एक पेशेवर मूल्यांकन मानकीकृत प्रशासन, सुरक्षित सामग्री, उपयुक्त आयु मानदंड, कई उप-परीक्षाएं और व्यवहारिक अवलोकनों का उपयोग करता है।",
        "उपकरण नाम तथा संस्करण, नॉर्म समूह, स्कोर क़िस्म, भरोसे की अवधि तथा सीमाओं के लिए पूछें. मूल रिपोर्ट को रखें यदि आपको बाद में योग्य परिणाम के प्रमाण की आवश्यकता हो."
      ]
    }
  ],
  "faqs": [
    {
      "question": "क्या एक मुक्त ऑनलाइन परीक्षण मुझे मेरा सटीक IQ बता सकता है?",
      "answer": "यह एक संकेतात्मक अनुमान प्रदान कर सकता है यदि इसे अच्छी तरह से डिजाइन किया गया हो, लेकिन यह एक सटीक, स्थायी या नैदानिक स्कोर स्थापित नहीं कर सकता है।"
    },
    {
      "question": "कौन आधिकारिक आईक्यू परीक्षण का प्रबंधन कर सकता है?",
      "answer": "मानकीकृत नैदानिक परीक्षण आमतौर पर उचित योग्य पेशेवरों द्वारा प्रशासित और व्याख्या की जाती है।"
    }
  ],
  "related": ["is-an-online-iq-test-accurate", "how-is-iq-measured", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "1. मनोविज्ञान का इतिहास - मनोविज्ञान का इतिहास",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "पीरसन - डब्ल्यूएआईएस-5 नमूना अंक रिपोर्ट",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    },
    {
      "label": "मेनसा इंटरनेशनल - अपने आईक्यू परीक्षण प्राप्त करना",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
